'use client'

import * as AccordionPrimitive from '@radix-ui/react-accordion'
import * as React from 'react'

import { cn } from '@/lib/utils'

/**
 * SEO-optimized AccordionContent component for FilterList
 * Uses forceMount to keep content in DOM for SEO crawling
 * Content is visually hidden when closed but remains in DOM
 */
export const SEOAccordionContent = React.forwardRef<
  React.ElementRef<typeof AccordionPrimitive.Content>,
  React.ComponentPropsWithoutRef<typeof AccordionPrimitive.Content>
>(({ className, children, ...props }, ref) => (
  <AccordionPrimitive.Content
    ref={ref}
    forceMount
    className={cn(
      'overflow-hidden text-sm transition-all',
      'data-[state=closed]:animate-accordion-up',
      'data-[state=open]:animate-accordion-down',
      // Ẩn visual khi đóng nhưng vẫn giữ trong DOM cho SEO
      'data-[state=closed]:h-0',
      'data-[state=closed]:opacity-0'
    )}
    {...props}
  >
    <div className={cn('pb-4 pt-0', className)}>{children}</div>
  </AccordionPrimitive.Content>
))

SEOAccordionContent.displayName = 'SEOAccordionContent'
